import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { usePermissions } from 'hooks/usePermissions'
import { FormattedMessage } from 'react-intl'
import { Tabs } from 'antd'
// TODO: fix dependencies js -> tsx + module definitions
import Organizations from 'containers/Organizations/Organizations'
import Users from 'containers/Users'
import Zones from 'containers/Zones'
import Groups from 'containers/Groups'
import Verticals from 'containers/Verticals'
import NavigationHeader from 'components/NavigationHeader/NavigationHeader'
import {
  fetchGroups,
  fetchOrganizations,
  fetchUsers,
  fetchZones,
  onOrganizationsPageUnmount,
  selectCurrentUser,
  selectIsInitialized,
  setIsInitialized,
} from 'store/global'
import messages from './messages'
import styles from './OrganizationsPage.scss'
import userService from '../../services/user'

export default function OrganizationsPage() {
  const dispatch = useDispatch()
  const permissions = usePermissions()
  const history = useHistory()
  const currentUser = useSelector(selectCurrentUser)
  const isAdmin = userService.isAdmin(currentUser)
  const isAppInitialized = useSelector(selectIsInitialized)

  useEffect(() => {
    if (!isAppInitialized) return

    return () => {
      dispatch(onOrganizationsPageUnmount())
    }
  }, [isAppInitialized])

  useEffect(() => {
    if (!permissions.isInitialized) return

    dispatch(fetchUsers())
    dispatch(fetchZones())
    dispatch(fetchOrganizations())
    dispatch(fetchGroups())

    dispatch(setIsInitialized(true))
  }, [permissions])

  const { pathname } = useLocation()
  const { path } = useRouteMatch()

  const allTabs = [
    {
      key: 'organizations',
      to: `${path}/organizations`,
      isDisplayed: true,
    },
    {
      key: 'groups',
      to: `${path}/groups`,
      isDisplayed: true,
    },
    {
      key: 'zones',
      to: `${path}/zones`,
      isDisplayed: true,
    },
    {
      key: 'users',
      to: `${path}/users`,
      isDisplayed: true,
    },
    {
      key: 'verticals',
      to: `${path}/verticals`,
      isDisplayed: isAdmin,
    },
  ]

  const displayedTabs = allTabs.filter(({ isDisplayed }) => isDisplayed)

  const getCurrentActiveKey = () => {
    if (pathname === path) return 'organizations'
    const currentTab = displayedTabs.find(({ key }) => {
      const tabPath = `${path}/${key}`
      return pathname === tabPath
    })
    return currentTab ? currentTab.key : 'organizations'
  }

  const activeKey = getCurrentActiveKey()

  const handleTabChange = key => {
    const tab = displayedTabs.find(t => t.key === key)
    if (tab) {
      history.push(tab.to)
    }
  }

  const tabItems = displayedTabs.map(tab => ({
    key: tab.key,
    label: (
      <span className={styles.tabTitle}>
        <FormattedMessage {...messages.tabTitles[tab.key]} />
      </span>
    ),
  }))

  return (
    <main className={styles.container}>
      <nav id='navigationHeaderWrapper' className={styles.navigationHeaderWrapper}>
        <NavigationHeader />
      </nav>
      <div className={styles.content}>
        <Tabs activeKey={activeKey} onChange={handleTabChange} items={tabItems} type='line' size='large' />
        <Switch>
          <Route path={`${path}/users`} component={Users} />
          <Route path={`${path}/organizations`} component={Organizations} />
          <Route path={`${path}/zones`} component={Zones} />
          <Route path={`${path}/groups`} component={Groups} />
          {isAdmin && <Route path={`${path}/verticals`} component={Verticals} />}
          <Route exact path={path} component={Organizations} />
        </Switch>
      </div>
    </main>
  )
}
